import { Injectable } from '@angular/core';
import { LoginResponseModel } from '../../core/models';

// Stores the current logged-in user in browser local storage.
@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  // Storage key.
  private readonly storageKey = 'ecb_current_user';

  // Save current user.
  setCurrentUser(user: LoginResponseModel): void {
    localStorage.setItem(this.storageKey, JSON.stringify(user));
  }

  // Read current user.
  getCurrentUser(): LoginResponseModel | null {
    const raw = localStorage.getItem(this.storageKey);
    return raw ? JSON.parse(raw) as LoginResponseModel : null;
  }

  // Check login.
  isLoggedIn(): boolean {
    return !!this.getCurrentUser()?.accessToken;
  }

  // Check role.
  hasRole(roleCode: string): boolean {
    return this.getCurrentUser()?.roleCode === roleCode;
  }

  // Clear session.
  clear(): void {
    localStorage.removeItem(this.storageKey);
  }
}
